/** Rückgabe-Kiste (Screen mieter/Rueckgabe-Kiste): Artikel mit Grund und Datum, Hinweis, Öffnungszeiten. */
import { useTx } from "../i18n";
import { Link } from "react-router";
import { EmptyState, Illustration, Notice, Seitenzustand } from "../ui";
import { ItemRow } from "../ui/ItemRow";
import { Card } from "../ui/Layout";
import { formatTag } from "@shared/zeit";
import { oeffnungszeitenText, useRueckgabeKiste } from "./api";
import { fotoUrl } from "./artikel-api";

const GRUND: Record<string, string> = { defekt: "Defekt", gefaellt_nicht: "Gefällt nicht", umtausch: "Umtausch" };

export function RueckgabeKiste() {
  const tx = useTx();
  const q = useRueckgabeKiste();
  return (
    <Seitenzustand query={q} lines={4}>
      {(d) => (
        <div className="sc-col" style={{ gap: "var(--space-4)" }}>
          <div className="sc-row">
            <Link to="/mieter" className="rg-btn rg-btn--quiet" aria-label="Zurück">‹</Link>
            <h1 className="title">{tx("Rückgabe-Kiste")}</h1>
          </div>
          {d.artikel.length === 0 ? (
            <EmptyState illustration="return-box" title={tx("Nichts in der Kiste")}>Zurückgegebene oder aussortierte Artikel von dir landen hier – mit Grund und Datum.</EmptyState>
          ) : (
            <>
              <div className="sc-center" style={{ gap: "var(--space-2)" }}>
                <Illustration name="return-box" />
                <h2 className="heading">{d.artikel.length === 1 ? "1 Artikel wartet" : `${d.artikel.length} Artikel warten`} im Laden auf dich</h2>
                <p className="sc-muted">{tx("Sie liegen in der Rückgabe-Kiste hinter der Kasse.")}</p>
              </div>
              <div>
                {d.artikel.map((a) => (
                  <div key={a.id}><ItemRow title={a.bezeichnung} photo={fotoUrl(a.fotoKey)} meta={`Zurückgegeben am ${formatTag(a.statusAt.slice(0, 10))}${a.grund ? ` · Grund: ${GRUND[a.grund] ?? a.grund}` : ""}${a.notiz ? ` · ${a.notiz}` : ""}`} price={a.preisCent} />{a.rueckgabeFoto ? <img src={fotoUrl(a.rueckgabeFoto)} alt="Artikel in der Rückgabe-Kiste" style={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: "var(--radius-md)", margin: "4px 0 var(--space-3)" }} /> : null}</div>
                ))}
              </div>
              <Notice tone="attention" title={tx("Bitte beim nächsten Besuch abholen")}>Räum die Artikel wieder ein oder nimm sie mit. Frag einfach an der Kasse.</Notice>
            </>
          )}
          <Card title={tx("Öffnungszeiten")}>
            {oeffnungszeitenText(d.oeffnungszeiten).map((z) => <div key={z}>{z}</div>)}
          </Card>
        </div>
      )}
    </Seitenzustand>
  );
}
